<script setup lang="ts">
import { useContextsStore } from '../../stores/contexts'
import { useScroll } from '@vueuse/core'

const { directions } = useScroll(window, { behavior: 'smooth' })

const isShowingHeader = ref<boolean>(true)

const user = useSupabaseUser()

const isOnline = computed(() => {
  return user.value !== null
})

const isSidebarMenuOpen = ref<boolean>(false)
const contextsStore = useContextsStore()

watch(directions, (newValue) => {
  if (newValue.bottom) {
    isShowingHeader.value = false
  }
  if (newValue.top) {
    isShowingHeader.value = true
  }
})
</script>

<template>
  <header
    class="fixed left-0 right-0 top-0 z-30 duration-100 transition-all bg-primary text-inverted px-4 flex justify-between items-center gap-2 h-16"
    :class="isShowingHeader ? 'translate-y-0' : 'fixed -translate-y-20'"
  >
    <!-- Menu button -->
    <USlideover v-model:open="isSidebarMenuOpen" side="left">
      <UButton
        :title="$t('open_menu')"
        variant="ghost"
        class="text-current"
        icon="i-mingcute-menu-line"
      />
      <template #content>
        <SidebarMenu />
      </template>
    </USlideover>
    <!-- Title -->
    <div class="flex justify-center">
      <UButton
        variant="solid"
        class="w-full px-4 py-2 rounded-3xl text-ellipsis overflow-hidden"
        color="primary"
        icon="i-mingcute-classify-line"
        :label="contextsStore.currentContext?.name"
        size="lg"
        @click="contextsStore.openContextSelector"
      />
    </div>
    <!-- Sync status -->
    <MobileSyncButton :online="isOnline" />
  </header>
  <div
    class="sticky px-4 mb-2 z-30 transition-all duration-200 backdrop-blur-xl bg-default/60"
    :class="isShowingHeader ? 'top-16' : 'top-0 shadow-lg'"
  >
    <slot name="subheader" />
  </div>
</template>
